module.exports = __webpack_public_path__ + "static/media/Factorio Guide - Smart Train Stations.d57630e0.png";